<script>
import {computed} from "vue";
import {mapState} from "vuex";

import {defineAsyncComponent} from 'vue'

const Dimensions = defineAsyncComponent(() =>
    import('@/components/filter/Dimensions.vue')
)
const Fields = defineAsyncComponent(() =>
    import('@/components/filter/Fields.vue')
)
const SDG = defineAsyncComponent(() =>
    import('@/components/filter/SDG.vue')
)

export default {
  components: {
    Dimensions,
    Fields,
    SDG
  },
  inject: ['jsonData'],
  data: () => {
    return {
      level1Filters: [
        'dimensions',
        'fields',
        'sdg'
      ],
      windowWidth: window.innerWidth,
    };
  },
  provide() {
    return {
      windowWidth: computed(() => this.windowWidth)
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  computed: {
    ...mapState({
      level1Filter: 'level1Filter',
    })
  },
  methods: {
    changeLevel1Filter(filter) {
      // Reset level 2 filter
      this.$store.commit('changeLevel2Filter', {title: null, key: null});

      // Change level 1 filter
      this.$store.commit('changeLevel1Filter', filter);
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    }
  }
}
</script>

<template>
  <div class="container">
    <div class="flex flex-col xl:flex-row">
      <h2 class="text-3xl text-black font-bold mb-6 lg:mb-12 hyphens-auto order-2 xl:order-1">{{ $t("filter.header") }}</h2>
    </div>
    <div class="flex flex-wrap mb-15">
      <button @click="changeLevel1Filter(filter)" v-for="(filter, key, index) in level1Filters"
              :class="{ 'bg-red-300 text-white border-red-300': level1Filter === filter }"
              class="flex basis-full md:basis-1/3	justify-center items-center h-16 text-gray-700 text-xl	lg:text-2xl border border-gray-700 hover:bg-red-300 hover:text-white transition-colors hover:border-red-300">
        {{ $t("filter." + filter) }}
      </button>
    </div>

    <div class="-mx-[30px] sm:mx-0 min-h-[244px]">
      <Dimensions v-if="level1Filter === 'dimensions'"></Dimensions>

      <Fields v-if="level1Filter === 'fields'"></Fields>

      <SDG v-if="level1Filter === 'sdg'"></SDG>
    </div>

  </div>
</template>

<style>
.flicking-arrow-prev, .flicking-arrow-next {
  top: calc(50% - 18px);
  height: 36px;
  width: 36px;
  border-radius: 50%;
  box-shadow: 0px 3px 6px #00000029;
  transition: box-shadow 0.2s;
}

.flicking-arrow-prev:hover, .flicking-arrow-next:hover {
  box-shadow: 0px 1px 10px #707070;
}

.flicking-arrow-prev {
  background-image: url("@/assets/images/arrow-left.svg");
}
.flicking-arrow-next {
  background-image: url("@/assets/images/arrow-right.svg");
}

.flicking-arrow-prev.flicking-arrow-disabled {
  background-image: url("@/assets/images/arrow-left-inactive.svg");
}
.flicking-arrow-next.flicking-arrow-disabled {
  background-image: url("@/assets/images/arrow-right-inactive.svg");
}

.flicking-arrow-disabled:hover {
  box-shadow: 0px 3px 6px #00000029;
}

.flicking-arrow-prev::before, .flicking-arrow-prev::after {
  display: none;
  right: 0;
  left: unset;
}

.flicking-arrow-next::before, .flicking-arrow-next::after {
  display: none;
  left: 0;
  right: unset;
}

.flicking-arrow-prev::before, .flicking-arrow-prev::after, .flicking-arrow-next::before, .flicking-arrow-next::after {
  width: 100%;
  background-color: #E30613!important;
}

.flicking-pagination-bullet-active {
  background-color: #E30613!important;
}

.flicking-pagination-scroll {
  width: auto!important;
}
</style>
